











import RadioList from '@front-app/components/inputs/RadioList.vue';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import {
	computed,
	defineComponent,
	PropType,
	Ref,
} from '@vue/composition-api';
import { DigestTimingDay, MonthlyTimingKey } from '../../model';
import { MONTHLY_LABEL_STRINGS, WEEKLY_LABEL_STRINGS } from '../../util/i18n';
import { DigestScheduleType } from '../../util/scheduling';

export default defineComponent({
	components: { RadioList },
	props: {
		selectedScheduleType: {
			type: String as PropType<DigestScheduleType>,
			required: true,
		},
		monthWeek: {
			type: String as PropType<MonthlyTimingKey>,
			required: true,
		},
		weekDay: {
			type: String as PropType<DigestTimingDay>,
			required: true,
		},
	},
	setup(props, ctx) {
		// Labels
		const weeklyLabel = computed(() => ctx.root.$t(WEEKLY_LABEL_STRINGS[props.weekDay]) as unknown as string);
		const monthlyLabel = computed(() => ctx.root.$t(MONTHLY_LABEL_STRINGS[props.monthWeek][props.weekDay]) as unknown as string);
		const customLabel = computed(() => ctx.root.$t('digests.scheduling-labels.custom') as unknown as string);

		const choices: Ref<SelectBoxChoice[]> = computed(() => [
			{
				key: DigestScheduleType.WEEKLY_SAME_DAY,
				label: weeklyLabel.value,
			},
			{
				key: DigestScheduleType.MONTHLY_SAME_DAY,
				label: monthlyLabel.value,
			},
			{
				key: DigestScheduleType.CUSTOM,
				label: customLabel.value,
			},
		]);
		const currentSelectionLabel = computed(() => {
			switch (props.selectedScheduleType) {
			case DigestScheduleType.UNSCHEDULED:
			case DigestScheduleType.PERIODIC:
				return 'Select Schedule Type';
			case DigestScheduleType.WEEKLY_SAME_DAY:
				return weeklyLabel.value;
			case DigestScheduleType.MONTHLY_SAME_DAY:
				return monthlyLabel.value;
			case DigestScheduleType.CUSTOM:
				return customLabel.value;
			default:
				// eslint-disable-next-line
				const exhaustiveCheck: never = props.selectedScheduleType;
				throw new Error(`Unhandled placeholder case: ${exhaustiveCheck}`);
			}
		});
		return {
			currentSelectionLabel,
			choices,
		};
	},
});
